module.exports = __webpack_public_path__ + "assets/icons/ic_gavel-d197.svg";